var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.optionModel.responsive
        ? _c(
            "el-form-item",
            { attrs: { label: "栅格宽度" } },
            [
              _c("el-input-number", {
                staticStyle: { width: "100%" },
                attrs: { min: 1, max: 24 },
                model: {
                  value: _vm.optionModel.span,
                  callback: function ($$v) {
                    _vm.$set(_vm.optionModel, "span", _vm._n($$v))
                  },
                  expression: "optionModel.span",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !!_vm.optionModel.responsive && _vm.formConfig.layoutType === "PC"
        ? _c(
            "el-form-item",
            { attrs: { label: "栅格宽度(PC)" } },
            [
              _c("el-input-number", {
                staticStyle: { width: "100%" },
                attrs: { min: 1, max: 24 },
                model: {
                  value: _vm.optionModel.md,
                  callback: function ($$v) {
                    _vm.$set(_vm.optionModel, "md", _vm._n($$v))
                  },
                  expression: "optionModel.md",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !!_vm.optionModel.responsive && _vm.formConfig.layoutType === "Pad"
        ? _c(
            "el-form-item",
            { attrs: { label: "栅格宽度(Pad)" } },
            [
              _c("el-input-number", {
                staticStyle: { width: "100%" },
                attrs: { min: 1, max: 24 },
                model: {
                  value: _vm.optionModel.sm,
                  callback: function ($$v) {
                    _vm.$set(_vm.optionModel, "sm", _vm._n($$v))
                  },
                  expression: "optionModel.sm",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !!_vm.optionModel.responsive && _vm.formConfig.layoutType === "H5"
        ? _c(
            "el-form-item",
            { attrs: { label: "栅格宽度(H5)" } },
            [
              _c("el-input-number", {
                staticStyle: { width: "100%" },
                attrs: { min: 1, max: 24 },
                model: {
                  value: _vm.optionModel.xs,
                  callback: function ($$v) {
                    _vm.$set(_vm.optionModel, "xs", _vm._n($$v))
                  },
                  expression: "optionModel.xs",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }